export const MISSING_CUSTOMER = 'Missing Customer';
export const MISSING_CUSTOMER_TOKEN = 'Missing Customer Token';
